define('home/models/UserModerationDetails',[
    'backbone',

    'home/utils/backboneUtils',

    'core/api',
], function (
    Backbone,

    backboneUtils,

    api
) {
    'use strict';

    var UserModerationDetails = Backbone.Model.extend({
        idAttribute: 'username',
        url: api.getURL('internal/users/moderationDetails'),

        initialize: function (options) {
            options = options || {};
            this.forum = options.forum;
            this.network = options.network;
        },

        shouldFetch: function () {
            return !this.get('username') || !this.get('forumsPostedIn');
        },

        fetch: function () {
            var options = {
                data: {
                    user: 'username:' + this.get('username'),
                    forum: this.forum || null,
                    network: this.network ? 'username:' + this.network : null,
                },
            };

            return backboneUtils.memoizedFetch.call(this, options);
        },

        ensureFetched: function () {
            if (this.shouldFetch())
                this.fetch();
        },

        parse: function (response) {
            return response.response;
        },

    });

    return UserModerationDetails;
});

